import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="time-countdown"
export default class extends Controller {
  static values = {
    datetime: String,
    prefix: String,
    endedMessage: String,
    compact: Boolean,
    unitLabels: Object,
  };

  connect() {
    this.endTimeMs = this.parseEndTime();

    if (!this.endTimeMs) return;

    this.update();
    this.timer = setInterval(() => this.update(), 1000);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  parseEndTime() {
    const raw =
      this.datetimeValue || this.element.getAttribute("datetime") || "";
    const parsed = new Date(raw).getTime();
    return Number.isNaN(parsed) ? null : parsed;
  }

  update() {
    const remainingSeconds = Math.max(
      0,
      Math.floor((this.endTimeMs - Date.now()) / 1000),
    );

    if (remainingSeconds === 0) {
      this.finish();
      return;
    }

    this.element.textContent = `${this.prefixValue || ""}${this.format(
      remainingSeconds,
    )}`.trim();
  }

  finish() {
    this.element.dispatchEvent(new CustomEvent("ended"));
    this.element.textContent = this.endedMessageValue || this.format(0);
    clearInterval(this.timer);
  }

  reloadPage() {
    if (window.Turbo?.visit) {
      window.Turbo.visit(window.location.href, { action: "replace" });
      return;
    }

    window.location.reload();
  }

  format(totalSeconds) {
    const days = Math.floor(totalSeconds / 86400);
    const months = Math.floor(days / 30);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const units = [
      ["years", Math.floor(months / 12)],
      ["months", months % 12],
      ["days", days % 30],
      ["hours", hours],
      ["minutes", minutes],
      ["seconds", seconds],
    ];
    const firstUnit = units.findIndex(
      ([unit, value]) => value > 0 || unit === "seconds",
    );
    const visibleUnits = this.compactValue
      ? units.slice(firstUnit, firstUnit + 2)
      : units;

    return visibleUnits
      .filter(([unit, value]) => value > 0 || unit === "seconds")
      .map(([unit, value]) => `${value}${this.unitLabelsValue[unit]}`)
      .join(" ");
  }
}
